export default __webpack_public_path__ + "static/trusted-media-brands-fbac3a69bb813a50ed8f8faf6c86325c.png";